/**
 * X-Axis Component
 *
 * Renders the X-axis with date labels.
 */

import { CHART_CONFIG } from "../constants";
import { getChartDimensions, indexToX, formatMonthLabel } from "../utils";
import type { PerformanceDataPoint } from "../types";

interface XAxisProps {
  data: PerformanceDataPoint[];
}

/**
 * X-axis with date labels
 */
export function XAxis({ data }: XAxisProps) {
  const { innerHeight } = getChartDimensions();
  const axisY = CHART_CONFIG.paddingTop + innerHeight;

  // Show labels at intervals to avoid crowding
  const labelInterval = Math.max(1, Math.floor(data.length / 6));

  return (
    <g className="x-axis">
      {/* Axis line */}
      <line
        x1={CHART_CONFIG.paddingLeft}
        y1={axisY}
        x2={CHART_CONFIG.width - CHART_CONFIG.paddingRight}
        y2={axisY}
        stroke="currentColor"
        strokeOpacity={0.2}
        strokeWidth={1}
      />
      {/* Date labels */}
      {data.map((point, index) => {
        if (index % labelInterval !== 0 && index !== data.length - 1) {
          return null;
        }
        const x = indexToX(index, data.length);
        return (
          <text
            key={point.date}
            x={x}
            y={axisY + 16}
            textAnchor="middle"
            className="fill-muted-foreground text-[9px]"
          >
            {formatMonthLabel(point.date)}
          </text>
        );
      })}
    </g>
  );
}
